/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityFindingsFilters } from './ControlEntityFindingsFilters';
import {
    ControlEntityFindingsFiltersFromJSON,
    ControlEntityFindingsFiltersFromJSONTyped,
    ControlEntityFindingsFiltersToJSON,
} from './ControlEntityFindingsFilters';
import type { ControlEntityFindingsResult } from './ControlEntityFindingsResult';
import {
    ControlEntityFindingsResultFromJSON,
    ControlEntityFindingsResultFromJSONTyped,
    ControlEntityFindingsResultToJSON,
} from './ControlEntityFindingsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityFindingsResponse
 */
export interface ControlPaginatedEntityFindingsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityFindingsResult>}
     * @memberof ControlPaginatedEntityFindingsResponse
     */
    results: Array<ControlEntityFindingsResult>;
    /**
     * 
     * @type {ControlEntityFindingsFilters}
     * @memberof ControlPaginatedEntityFindingsResponse
     */
    filters: ControlEntityFindingsFilters;
}

/**
 * Check if a given object implements the ControlPaginatedEntityFindingsResponse interface.
 */
export function instanceOfControlPaginatedEntityFindingsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "filters" in value;

    return isInstance;
}

export function ControlPaginatedEntityFindingsResponseFromJSON(json: any): ControlPaginatedEntityFindingsResponse {
    return ControlPaginatedEntityFindingsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityFindingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityFindingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlEntityFindingsResultFromJSON)),
        'filters': ControlEntityFindingsFiltersFromJSON(json['filters']),
    };
}

export function ControlPaginatedEntityFindingsResponseToJSON(value?: ControlPaginatedEntityFindingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlEntityFindingsResultToJSON)),
        'filters': ControlEntityFindingsFiltersToJSON(value.filters),
    };
}

